<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Pipelines</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <div  v-if="tableData.length > 0">
        <b-row>
          <b-col>
            <b-card no-body>
              <b-row align-v="center" slot="header">
                <b-col>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <h6 class="text-uppercase ls-1 mb-1">Active Pipeline Ratings</h6>
                      <h5 class="h3 mb-0">Count</h5>
                    </div>
                    <b-button variant="danger" @click="exportItems">Export Results</b-button>
                  </div>
                </b-col>
              </b-row>
              <b-table responsive id="agent-report" small :items="tableData" :fields="columns" no-sort-reset foot-clone>
                <template #cell(ten)="row">
                  <span v-if="row.item.ten > 0">
                    <b-link :to="'/pipelines?rating=10'" v-if="user.slug == row.item.slug">{{ row.item.ten }}</b-link>
                    <b-link :to="'/observatory/' + row.item.slug + '/pipelines?rating=10'" v-else>{{ row.item.ten }}</b-link>
                  </span>
                  <span v-else>{{ row.item.ten }}</span>
                </template>
                <template #cell(nine)="row">
                  <span v-if="row.item.nine > 0">
                    <b-link :to="'/pipelines?rating=9'" v-if="user.slug == row.item.slug">{{ row.item.nine }}</b-link>
                    <b-link :to="'/observatory/' + row.item.slug + '/pipelines?rating=9'" v-else>{{ row.item.nine }}</b-link>
                  </span>
                  <span v-else>{{ row.item.nine }}</span>
                </template>
                <template #cell(eight)="row">
                  <span v-if="row.item.eight > 0">
                    <b-link :to="'/pipelines?rating=8'" v-if="user.slug == row.item.slug">{{ row.item.eight }}</b-link>
                    <b-link :to="'/observatory/' + row.item.slug + '/pipelines?rating=8'" v-else>{{ row.item.eight }}</b-link>
                  </span>
                  <span v-else>{{ row.item.eight }}</span>
                </template>
                <template #cell(seven)="row">
                  <span v-if="row.item.seven > 0">
                    <b-link :to="'/pipelines?rating=7'" v-if="user.slug == row.item.slug">{{ row.item.seven }}</b-link>
                    <b-link :to="'/observatory/' + row.item.slug + '/pipelines?rating=7'" v-else>{{ row.item.seven }}</b-link>
                  </span>
                  <span v-else>{{ row.item.seven }}</span>
                </template>
                <template #cell(six)="row">
                  <span v-if="row.item.six > 0">
                    <b-link :to="'/pipelines?rating=6'" v-if="user.slug == row.item.slug">{{ row.item.six }}</b-link>
                    <b-link :to="'/observatory/' + row.item.slug + '/pipelines?rating=6'" v-else>{{ row.item.six }}</b-link>
                  </span>
                  <span v-else>{{ row.item.six }}</span>
                </template>
                <template #cell(five)="row">
                  <span v-if="row.item.five > 0">
                    <b-link :to="'/pipelines?rating=5'" v-if="user.slug == row.item.slug">{{ row.item.five }}</b-link>
                    <b-link :to="'/observatory/' + row.item.slug + '/pipelines?rating=5'" v-else>{{ row.item.five }}</b-link>
                  </span>
                  <span v-else>{{ row.item.five }}</span>
                </template>

                <template #foot(agent)="row">
                  Totals
                </template>
                <template #foot(ten)="row">
                  {{ totalTens }}
                </template>
                <template #foot(nine)="row">
                  {{ totalNines }}
                </template>
                <template #foot(eight)="row">
                  {{ totalEights }}
                </template>
                <template #foot(seven)="row">
                  {{ totalSevens }}
                </template>
                <template #foot(six)="row">
                  {{ totalSixes }}
                </template>
                <template #foot(five)="row">
                  {{ totalFives }}
                </template>
              </b-table>
            </b-card>
          </b-col>
        </b-row>
        <b-row>
          <pipeline-chart
            :title="'Potential Volume'"
            :userRoute="userRoute"
            :type="'volume'"
            :size="'4'">
          </pipeline-chart>
          <pipeline-chart
            :title="'Potential GCI'"
            :userRoute="userRoute"
            :type="'gci'"
            :size="'4'">
          </pipeline-chart>
          <pipeline-chart
            :title="'Potential Profit'"
            :userRoute="userRoute"
            :type="'profit'"
            :size="'4'">
          </pipeline-chart>
        </b-row>
      </div>
      <div v-else>
        <loading-panel></loading-panel>
      </div>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import errorsMixin from '@/mixins/errors-mixin';
import { mapGetters } from 'vuex';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import PipelineChart from '@/views/Components/Charts/PipelineChart';
import LoadingPanel from '@/components/LoadingPanel';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb,
    PipelineChart,
    LoadingPanel
  },
  data() {
    return {
      items: null,
      tableData: [],
      columns: ['agent', 'ten', 'nine', 'eight', 'seven', 'six', 'five']
    }
  },
  computed: {
    ...mapGetters({
      user: 'profile/user',
      userRoute: 'profile/userRoute',
    }),
    totalTens() {
      return this.tableData.reduce(function (total, value) {
        return total + value.ten;
      }, 0);
    },
    totalNines() {
      return this.tableData.reduce(function (total, value) {
        return total + value.nine;
      }, 0);
    },
    totalEights() {
      return this.tableData.reduce(function (total, value) {
        return total + value.eight;
      }, 0);
    },
    totalSevens() {
      return this.tableData.reduce(function (total, value) {
        return total + value.seven;
      }, 0);
    },
    totalSixes() {
      return this.tableData.reduce(function (total, value) {
        return total + value.six;
      }, 0);
    },
    totalFives() {
      return this.tableData.reduce(function (total, value) {
        return total + value.five;
      }, 0);
    },
  },
  methods: {
    async getItems() {
      await axios.get(this.userRoute + "/reports/pipelines/count")
      .then(response => {
        this.tableData = response.data;
      })
      .catch(error => {
        this.error(error);
      });
    },
    updateRating(rating) {
      this.rating = rating;
    },
    async exportItems() {
      await axios.get(this.userRoute + "/reports/pipelines/export")
      .then(response => {
        swal.fire({
          title: 'Export Complete',
          text: response.data.message,
          icon: 'success',
          confirmButtonColor: '#009347',
          confirmButtonText: 'Download Active Pipeline Ratings Report',
        }).then(result => {
          if (result.value) {
            window.open(response.data.link, "_blank");
          }
        });
      })
      .catch(error => {
        this.error(error);
      });
    },
  },
  created() {
    this.getItems();
  }
};
</script>